<!-- Body -->
<ng-container #container *ngIf="!share">
  <h1 class="d-none" (load)="checkUrlAndOpenPopUp()">Kachiing Biz</h1>

  <div class="tabs container">
    <img loading="lazy" class="my-banner" src="assets/images/new/Banner_marketplace_2.jpg" alt="" />
    <app-my-carousel-swiper [navigation]="false" [centerSlider]="true" class="my-carousel-width-auto" [slide]="categories" [config]="carouselOptions" *ngIf="categories && categories.length > 0 && isBrowser">
      <div class="swiper-slide">
        <div [class.active]="'' == this.selectedCatId" class="tab" [routerLink]="['/biz']" (click)="applySpecialCategoryFilter('Popular Now', true)">
          <div>
            <i class="fa-solid fa-star"></i>
            <div class="text">Popular</div>
          </div>
        </div>
      </div>
      <div class="swiper-slide" *ngFor="let tab of categories">
        <a (click)="tabChange(tab)" [class.active]="tab.id == this.selectedCatId" class="tab">
          <div>
            <i class="fa-solid fa-{{ categoryIconMap[tab.name?.toUpperCase()] }}"></i>
            <div class="text">{{ tab.name }}</div>
          </div>
        </a>
      </div>
    </app-my-carousel-swiper>
    <h2 class="d-none">Categories</h2>
    <h3 class="d-none">POPUPLAR</h3>
    <h3 class="d-none" *ngFor="let tab of categories">{{ tab.name?.toUpperCase() }}</h3>

    <!-- <div class="text-center">
        (click)="subCatTabChange(sub)"  
      <a class="sub-tab" *ngFor="let sub of subcategories; index as i" [ngClass]="{ active: selectedsubCatId == sub.id }" (click)="subCatTabChange(sub); getProductList(sub.id)">
        {{ sub.name }}
      </a>
    </div> -->
    <div class="bar">
      <div class="inputs">
        <div class="row">
          <div class="col-md-12">
            <div class="my-input search" style="position: relative">
              <!-- <div class="my-input__title">Search</div> -->
              <input placeholder="Search" type="text" [(ngModel)]="searchProduct" (keydown.enter)="handleSearchProduct()" />
            </div>
          </div>
        </div>
      </div>
      <div class="icon-search" (click)="handleSearchProduct()">
        <i class="fa-solid fa-search"></i>
      </div>
    </div>
  </div>
  <section class="my-item-details">
    <div class="container">
      <router-outlet></router-outlet>

      <div class="text-center border-0 p-4" *ngIf="filteredProducts.data.length === 0 && !isLoadingMore">
        <img src="assets/images/no-found-products.png" alt="No Products" class="img-fluid mb-4" />
        <h2 class="card-title fw-bold text-secondary">No Products Found</h2>
        <p class="card-text text-muted">It seems we couldn’t find any products matching your search. Please try adjusting your filters or browse our categories.</p>
      </div>

      <div class="products">
        <!-- Product List -->
        <common-product-card-view *ngFor="let list of filteredProducts.data; let i = index" (view)="viewProduct($event)" [list]="list" [isCommunityProduct]="false"></common-product-card-view>
        <!-- Product List -->
      </div>
      <div class="show-more">
        @if(isLoadingMore){
        <div class="loader xs"></div>
        } @else {
        <div *ngIf="filteredProducts.currentPage < filteredProducts.totalPages" (click)="getProductList(selectedsubCatId, filteredProducts.nextPage)">Show more products <i class="fa-solid fa-chevron-down"></i></div>
        <div *ngIf="showMoreProduct && i == filteredProducts.data.length - 1" (click)="showMoreProduct = false">
          See less
          <i class="fa-solid fa-chevron-up"></i>
        </div>
        }
      </div>
    </div>
  </section>
  <div class="container">
    <div class="logos">
      <div class="logos__title">Brands That Matter</div>
      <app-my-carousel-swiper [config]="carouselOptionsLogos" *ngIf="brands && brands.length > 0">
        <div class="swiper-slide" *ngFor="let brand of brands">
          <div class="logos__card" (click)="openPopup(brand, BrandPopup)">
            <div class="image"><img loading="lazy" [src]="imgUrl + brand.image" alt="" /></div>
            <div class="title">{{ brand.name }}</div>
          </div>
        </div>
      </app-my-carousel-swiper>
    </div>
  </div>
</ng-container>

<!-- View Product Popup -->
<ng-template #viewProductModal let-modal>
  <div class="my-prod-detail__close" (click)="modal.close()" *ngIf="!food_details?.isTypeShop">
    <i class="fa-solid fa-times"></i>
    <i class="fas fa-chevron-left"></i>
  </div>
  @if( ( food_details?.attachmentProducts && sliderData[food_details['attachmentProducts']] ) || this.prevProduct){
  <app-my-carousel-swiper [cssClass]="'product-slide'" [config]="carouselOptions" [navigation]="true" (onSlideChange)="nextProduct($event)" [class]="'carousel-' + 0">
    <div class="swiper-slide">
      <app-view-product-details [productLoader]="isLoading" [modal]="modal" [addProductComponent]="addProductComponent" [productData]="food_details" (updated)="viewProductEvent(action)"></app-view-product-details>
    </div>
  </app-my-carousel-swiper>
  }@else{
  <app-view-product-details [productLoader]="isLoading" [modal]="modal" [addProductComponent]="addProductComponent" [productData]="food_details" (updated)="viewProductEvent(action)"></app-view-product-details>
  }
</ng-template>

<ng-template #forumProduct let-modal>
  <div id="forum_product_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <!-- <h5 class="mb-3">Product Details</h5> -->
            <i class="fa-regular fa-circle-xmark" (click)="modalService.dismissAll()"></i>
          </div>
          <div class="card border-0">
            <div class="card-body forum-title d-flex">
              <img loading="lazy" src="{{ imgUrl }}{{ shopForum.shop_logo }}" alt="" />
              <div class="my-auto pl-3">
                <h3 class="fw-bold">{{ shopForum.shop_name }}</h3>
                <h3>FORUMS</h3>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end my-2">
            <nav aria-label="...">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="shopForum.currentPage === 1">
                  <button class="page-link" (click)="getShopForum(productForum.adminId)">First</button>
                </li>
                <ng-container *ngFor="let page of getPages()">
                  <li class="page-item" [class.active]="page === shopForum.currentPage">
                    <button class="page-link" (click)="getShopForum(productForum.adminId, page)">
                      {{ page }}
                    </button>
                  </li>
                </ng-container>
                <li class="page-item" [class.disabled]="shopForum.currentPage === shopForum.lastPage">
                  <button class="page-link" (click)="getShopForum(productForum.adminId, shopForum.lastPage)">Last</button>
                </li>
              </ul>
            </nav>
          </div>
          <div *ngFor="let forum of shopForum?.list; let i = index" class="card mb-3">
            <div class="card-body">
              <div class="d-flex forum-product-child mb-2">
                <div *ngIf="isLogin == 1">
                  <span class="forum-product-toggle" (click)="handleShowOptionForum(i)">
                    <i class="fa-solid fa-ellipsis-v"></i>
                  </span>
                  <div class="forum-product-dropdown" [class.d-none]="!forum.showOption">
                    <a *ngIf="isModerator()" href="#" (click)="editForumMessage($event, i)"> <i class="fa-solid fa-pen"></i> Edit </a>
                    <a *ngIf="isModerator()" href="#" (click)="deleteForumMessage($event, forum.id)"> <i class="fa-solid fa-trash"></i> Delete </a>
                    <a href="#" (click)="showReplyMessageBox($event, i)"> <i class="fa-solid fa-comment-dots"></i> Reply </a>
                  </div>
                </div>
                <div class="d-flex flex-column flex-md-row w-100">
                  <div class="mb-2 text-left forum-product-who">
                    <h5>{{ forum.user.userName }}</h5>
                    <h6 class="text-muted">{{ forum.user.userType }}</h6>
                  </div>
                  <ng-container *ngIf="!forum.isEdit">
                    <div class="card {{ isOwnMessage(forum) ? 'forum-product-bubble-message-own' : 'forum-product-bubble-message' }}">
                      <small class="text-muted" style="position: absolute; right: 7px; top: 3px">{{ forum.createdAt }}</small>
                      <div class="card-body" [innerHtml]="forum.message"></div>
                    </div>
                  </ng-container>
                </div>
                <ng-container *ngIf="forum.isEdit">
                  <form (ngSubmit)="storeForumMessageEdit(forum.id)" class="w-100">
                    <app-editor [(innerValue)]="forum.messageEdit"></app-editor>
                    <div class="mt-3 float-right">
                      <button type="button" (click)="forum.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                      <button class="btn btn-primary" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                    </div>
                  </form>
                </ng-container>
                <br />
              </div>
              <button [disabled]="forum.repliesCount == 0" *ngIf="forum.repliesCount != 0" class="btn btn-sm btn-light accordion-forum rounded-sm forum-product-child-reply" (click)="getShopForumReply(i)">
                <div class="d-flex justify-content-between">
                  <p *ngIf="forum.repliesCount != 0">Show {{ forum.repliesCount }} replies</p>
                  <p><i class="pl-2 fa-solid fa-arrow-alt-circle-down"></i></p>
                </div>
              </button>
              <ng-container *ngIf="forum.showReply">
                <div *ngFor="let reply of forum.replies; let iReply = index" class="d-flex forum-product-child forum-product-child-reply mb-3 mt-2">
                  <div *ngIf="isModerator()">
                    <span class="forum-product-toggle" (click)="handleShowOptionForumReply(i, iReply)">
                      <i class="fa-solid fa-ellipsis-v"></i>
                    </span>
                    <div class="forum-product-dropdown" [class.d-none]="!reply.showOption">
                      <a href="#" (click)="editForumMessageReply($event, i, iReply)"> <i class="fa-solid fa-pen"></i> Edit </a>
                      <a href="#" (click)="deleteForumMessageReply($event, reply.id, i)"> <i class="fa-solid fa-trash"></i> Delete </a>
                    </div>
                  </div>
                  <div class="d-flex flex-column flex-md-row w-100">
                    <div class="mb-auto text-left forum-product-who">
                      <h5>{{ reply.user.userName }}</h5>
                      <h6 class="text-muted">{{ reply.user.userType }}</h6>
                    </div>
                    <ng-container *ngIf="!reply.isEdit">
                      <div class="card {{ isOwnMessage(reply) ? 'forum-product-bubble-message-own' : 'forum-product-bubble-message' }}">
                        <small class="text-muted" style="position: absolute; right: 7px; top: 3px">{{ reply.createdAt }}</small>
                        <div class="card-body" [innerHtml]="reply.message"></div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="reply.isEdit">
                      <form (ngSubmit)="storeForumMessageEdit(reply.id)" class="w-100">
                        <app-editor [(innerValue)]="reply.messageEdit"></app-editor>
                        <div class="mt-3 float-right">
                          <button type="button" (click)="reply.isEdit = false" class="btn btn-danger mr-2" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                          <button class="btn btn-primary" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                        </div>
                      </form>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="forum.showReplyBox">
                <form (ngSubmit)="storeForumMessageReply(i)" class="w-100 mt-2">
                  <app-editor [(innerValue)]="forum.replyText"></app-editor>
                  <div class="mt-3 float-right">
                    <button type="button" (click)="forum.showReplyBox = false; forum.showOption = false" class="btn btn-danger mr-2" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-times"></i> Cancel</button>
                    <button class="btn btn-primary" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send Reply</button>
                  </div>
                </form>
              </ng-container>
            </div>
          </div>
          <div *ngIf="shopForum?.list?.length < 1">
            <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are no discussions posted at this time</div>
          </div>
          <div class="my-3" *ngIf="isLogin == 1">
            <button class="btn btn-light w-100 accordion-forum" (click)="showMessageBoxForum = !showMessageBoxForum">
              <div class="d-flex justify-content-between">
                <p>Message Box</p>
                <p><i class="fa-solid fa-arrow-alt-circle-down"></i></p>
              </div>
            </button>
            <div class="card" *ngIf="showMessageBoxForum">
              <div class="card-body">
                <form (ngSubmit)="storeForumMessage()">
                  <app-editor [(innerValue)]="forum.messageEdit"></app-editor>
                  <div class="mt-3 float-right">
                    <button class="btn btn-primary" [class.disabled]="productForum.hasSubmit" [disabled]="productForum.hasSubmit"><i class="fa-solid fa-paper-plane"></i> Send</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="my-3" *ngIf="isLogin == 0">
            <div class="alert alert-danger" role="alert">
              <div class="d-flex flex-column flex-md-row justify-content-between">
                <span class="my-auto">
                  <i class="fa-solid fa-exclamation-circle"></i> Please log in first if you want to discuss in the <b>{{ shopForum?.userName }}</b> Forum
                </span>
                <button class="btn btn-sm btn-primary" (click)="openShopSigninPopup(shopSigninPopup)">Login Here !</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #shopSigninPopup let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <form [formGroup]="shop_signin_form">
        <div class="row">
          <div class="col-md-12">
            <div class="add_cattt">
              <i class="fa-regular fa-circle-xmark fa-2x" (click)="modalService.dismissAll()"></i>
            </div>
            <div class="">
              <h2 class="cart_title">Signin</h2>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="form-group">
              <input type="text" placeholder="Phone Number" class="form-control d-none d-md-block" formControlName="phone_number" />
              <input type="text" placeholder="Phone Number" class="form-control d-md-none d-block" readonly formControlName="phone_number" />
              <ng-container *ngIf="submitted && shopSigninV.phone_number.errors">
                <p class="error-message-repair" *ngIf="shopSigninV.phone_number.errors.required">Phone Number is required!</p>
              </ng-container>
              <ng-container *ngIf="submitted && shopSigninV.phone_number.errors">
                <p class="error-message-repair" *ngIf="shopSigninV.phone_number.errors.pattern">Enter valid phone number!</p>
              </ng-container>
              <ng-container *ngIf="submitted && shopSigninV.phone_number.errors">
                <p class="error-message-repair" *ngIf="shopSigninV.phone_number.errors.minlength">Invalid phone number!</p>
              </ng-container>
              <ng-container *ngIf="submitted && shopSigninV.phone_number.errors">
                <p class="error-message-repair" *ngIf="shopSigninV.phone_number.errors.maxlength">Invalid phone number!</p>
              </ng-container>
            </div>
          </div>
          <div class="col-md-12 d-md-none d-block">
            <div class="numpad-container">
              <div class="numpad">
                <button class="num" (click)="numpad(1)">1</button>
                <button class="num" (click)="numpad(2)">2</button>
                <button class="num" (click)="numpad(3)">3</button>
                <button class="num" (click)="numpad(4)">4</button>
                <button class="num" (click)="numpad(5)">5</button>
                <button class="num" (click)="numpad(6)">6</button>
                <button class="num" (click)="numpad(7)">7</button>
                <button class="num" (click)="numpad(8)">8</button>
                <button class="num" (click)="numpad(9)">9</button>
                <button class="num border-0"></button>
                <button class="num" (click)="numpad(0)">0</button>
                <button class="del" (click)="numpad('Del')">Del</button>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4">
            <div class="cart_btn">
              <a (click)="shop_sign_in()" class="btn btn-purple text-white">Enter </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #favoriteModal let-modal>
  <div id="favorite_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <!-- <h5 class="mb-3">Product Details</h5> -->
            <i class="fa-regular fa-circle-xmark" (click)="modalService.dismissAll()"></i>
          </div>
          <!-- <h4 class="mt-3 fw-bolder">
            PROFILE
          </h4> -->
          <h4 class="mt-3 fw-bolder">FAVORITES PRODUCT</h4>
          <div *ngFor="let fav of profile?.favorites" class="card shadow-sm border-light mt-2">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <img loading="lazy" style="max-height: 80px" src="{{ imgUrl }}{{ fav.food.foodImages[0] ? fav.food.foodImages[0]?.image : '' }}" alt="" />
                  <h6 class="pl-2">{{ fav.food.name }}</h6>
                </div>

                <span *ngIf="isLogin == 1" class="favorite-toggle-profile" (click)="handleFavoriteProduct(fav.foodId, false)">
                  <i class="fa-solid fa-heart"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #specialCategoryModal let-modal>
  <div id="special_category_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="add_cattt">
            <!-- <h5 class="mb-3">Product Details</h5> -->
            <i class="fa-regular fa-circle-xmark" (click)="modalService.dismissAll()"></i>
          </div>

          <h5 class="mt-3 fw-bolder">Popular</h5>
          <section class="">
            <div class="">
              <div class="mt-2 special-category-container">
                <!-- <owl-carousel-o [options]="specialCategoryCustomOptions" class="special-category-container-carousal">

                  <ng-container *ngFor="let cat of specialCategoriesPromotions">
                    <ng-template class="slide" carouselSlide [id]="cat.name">
                      <div class="d-flex flex-column align-items-center">
                        <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                          <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="72px" height="72px"
                            alt="Icon 1 description">
                          <i *ngIf="selectedSpecialCategories.includes(cat.name)"
                            class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                          <div *ngIf="!selectedSpecialCategories.includes(cat.name)"
                            class="special-cat-img-icon special-cat-img-circle-icon"></div>
                        </div>
                        <span class="special-cat-name mt-1">{{cat.name}}</span>
                      </div>
                    </ng-template>
                  </ng-container>

                </owl-carousel-o> -->
                <div class="special-category-grid-container">
                  <ng-container *ngFor="let cat of specialCategoriesPromotions">
                    <div class="d-flex flex-column align-items-center">
                      <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                        <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="72px" height="72px" alt="Icon 1 description" />
                        <i *ngIf="selectedSpecialCategories.includes(cat.name)" class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                        <div *ngIf="!selectedSpecialCategories.includes(cat.name)" class="special-cat-img-icon special-cat-img-circle-icon"></div>
                      </div>
                      <span class="special-cat-name mt-1">{{ cat.name }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>
          <!-- <h4 class="mt-3 fw-bolder">
            PROFILE
          </h4> -->
          <h5 class="mt-3 fw-bolder">Category</h5>
          <section class="">
            <div class="">
              <div class="mt-2 special-category-container">
                <!-- <owl-carousel-o [options]="specialCategoryCustomOptions" class="special-category-container-carousal">

                  <ng-container *ngFor="let cat of specialCategories">
                    <ng-template class="slide" carouselSlide [id]="cat.name">
                      <div class="d-flex flex-column align-items-center">
                        <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                          <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="80px" height="80px"
                            alt="Icon 1 description">
                          <i *ngIf="selectedSpecialCategories.includes(cat.name)"
                            class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                          <div *ngIf="!selectedSpecialCategories.includes(cat.name)"
                            class="special-cat-img-icon special-cat-img-circle-icon"></div>
                        </div>
                        <span class="special-cat-name mt-1">{{cat.name}}</span>
                      </div>
                    </ng-template>
                  </ng-container>

                </owl-carousel-o> -->
                <div class="special-category-grid-container">
                  <ng-container *ngFor="let cat of specialCategories">
                    <div class="d-flex flex-column align-items-center">
                      <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                        <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="72px" height="72px" alt="Icon 1 description" />
                        <i *ngIf="selectedSpecialCategories.includes(cat.name)" class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                        <div *ngIf="!selectedSpecialCategories.includes(cat.name)" class="special-cat-img-icon special-cat-img-circle-icon"></div>
                      </div>
                      <span class="special-cat-name mt-1">{{ cat.name }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>

          <h5 class="mt-3 fw-bolder">Delivery</h5>
          <section class="">
            <div class="">
              <div class="mt-2 special-category-container">
                <!-- <owl-carousel-o [options]="specialCategoryCustomOptions" class="special-category-container-carousal">

                  <ng-container *ngFor="let cat of specialCategoriesDelivery">
                    <ng-template class="slide" carouselSlide [id]="cat.name">
                      <div class="d-flex flex-column align-items-center">
                        <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                          <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="80px" height="80px"
                            alt="Icon 1 description">
                          <i *ngIf="selectedSpecialCategories.includes(cat.name)"
                            class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                          <div *ngIf="!selectedSpecialCategories.includes(cat.name)"
                            class="special-cat-img-icon special-cat-img-circle-icon"></div>
                        </div>
                        <span class="special-cat-name mt-1">{{cat.name}}</span>
                      </div>
                    </ng-template>
                  </ng-container>

                </owl-carousel-o> -->
                <div class="special-category-grid-container">
                  <ng-container *ngFor="let cat of specialCategoriesDelivery">
                    <div class="d-flex flex-column align-items-center">
                      <div (click)="applySpecialCategoryFilter(cat.name)" class="special-cat-img-container">
                        <img loading="lazy" [src]="cat.img" class="special-cat-elevation pointer" width="72px" height="72px" alt="Icon 1 description" />
                        <i *ngIf="selectedSpecialCategories.includes(cat.name)" class="fa fa-check-circle special-cat-img-icon" aria-hidden="true"></i>
                        <div *ngIf="!selectedSpecialCategories.includes(cat.name)" class="special-cat-img-icon special-cat-img-circle-icon"></div>
                      </div>
                      <span class="special-cat-name mt-1">{{ cat.name }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-add-shop *ngIf="enableMemberShop" #AddShop [enableMemberShop]="enableMemberShop"></app-add-shop>

<ng-template #BrandPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="form-group">
      <div class="logos__card">
        <div class="image"><img loading="lazy" [src]="imgUrl + selectedBrand?.image" alt="" /></div>
        <div class="title">{{ selectedBrand?.name | titlecase }}</div>
        <div class="">{{ selectedBrand?.description }}</div>
      </div>
    </div>
    <button class="d-flex ml-auto my-button-3" *ngIf="selectedBrand?.url" (click)="goToBrand(selectedBrand?.url)">Go To Brand<i class="fa fa-arrow-right" aria-hidden="true"></i></button>
  </div>
</ng-template>

<!-- <div #ProductViewShell class="custom-modal">
  <div class="modal-dialog d-block modal product_detail_popup">
    <div class="modal-content mt-5">
      <div class="my-prod-detail__close" >
        <i class="fa-solid fa-times"></i>
      </div>

      <div  class="modal-body my-prod-detail">
     
        <div  id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
         
          <div  class="my-prod-detail__body product_detail_body">
            <div  class="grid-image">
              <img  loading="lazy" class="main-image" src="https://demoapi.kachiing.com/null" style="background-image: url('../../../../../../assets/images/shop/default.png');" />
              <div  class="slide-images">
                <div  ng-reflect-ng-style="[object Object]" style="background-image: url('https://demoapi.kachiing.com/null');"></div>
              
                <div  ng-reflect-ng-style="[object Object]" style="background-image: url('https://demoapi.kachiing.com/null');"></div>
               
                <div  ng-reflect-ng-style="[object Object]" style="background-image: url('https://demoapi.kachiing.com/null');"></div>
                
                <div  ng-reflect-ng-style="[object Object]" style="background-image: url('https://demoapi.kachiing.com/null');"></div>
               
              </div>
            </div>
            <div  class="my-prod-detail__body--content">
              <div  class="row">
                <div  class="col-md-8">
                  <div  class="my-prod-detail__body--content__title">
                    <div >
                      <meta  itemprop="priceCurrency" content="SGD" />
                      <div  class="text">
                        <span  itemprop="price" class="price"></span
                        >
                      </div>
                    </div>
                  </div>
                  <div  class="detail-text">
                    <app-my-tabs  design="4"  ng-reflect-design="4"
                      ><div class="tabs">
               
                        <div class="tabs__content">
                          <div class="tabs__content--body">
                            <div  tab0="" class="mb-2"><div ></div></div>
                          
                          </div>
                        </div>
                      </div></app-my-tabs
                    >
                  </div>
                </div>
                <div  class="col-md-4" style="border-left: 1px solid rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.25);">
                  <app-my-tabs  design="3"  ng-reflect-design="3" ng-reflect-slider="true"
                    ><div class="tabs">
                      <owl-carousel-o  ng-reflect-options="[object Object]"
                        ><div  class="owl-carousel owl-theme" ng-reflect-ng-class="[object Object]">
                         
                        </div></owl-carousel-o
                      >
                      <div class="tabs__content">
                        <div class="tabs__content--body">
                          <div  tab0="">
                            <div  class="row product_detail_promo px-2">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div></app-my-tabs
                  >
                </div>
              </div>
              <div  class="add_cart mt-4 mb-4"></div>
              <div  class="mt-4 tabs-suggestions">
                <app-my-tabs  design="5"  ng-reflect-design="5" ng-reflect-tabs="[object Object]"
                  ><div class="tabs">
                    <div class="design-5 tabs__header">
                      <div class="tabs__header--item active" ng-reflect-ng-class="[object Object]">
                        Experiences
                      </div>
                    </div>
                    <div class="tabs__content">
                      <div class="tabs__content--body"><div  tab0=""></div></div>
                    </div></div
                ></app-my-tabs>
              </div>
              <div >
                <div  role="alert" class="alert alert-danger mt-2">
                  <div  class="d-flex flex-column flex-md-row justify-content-between">
                    <span  class="my-auto"><i  class="fa-solid fa-exclamation-circle"></i> Please log in first if you want to chat with user. </span><button  class="btn btn-sm btn-primary">Login Here !</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</div> -->
